module.exports = __webpack_public_path__ + "static/media/ibuzzer.1f228749.svg";